import { FC } from 'react';
import { AdFoxBanner } from '../../components/AdfoxBanner';
import { AdfoxContextData } from '../../utils/adfoxContext';
import { TAdfoxContextData } from '../../types';

export const AdfoxBannerContainer: FC<TAdfoxContextData> = props => {
  return (
    <AdfoxContextData.Provider value={props}>
      <AdFoxBanner />
    </AdfoxContextData.Provider>
  );
};
